import React, { useCallback } from "react";
import { Checkbox } from "components/Inputs";
import { useGetFileNameOrTitle } from "hooks";
import { toggleCheckboxState } from "utils";

export const CheckboxAccordionContent = ({
  title,
  itemsData,
  checked = false,
  setItemsData,
  toggle,
  id,
  expandedAccordionIds,
}) => {
  const getFileNameOrTitle = useGetFileNameOrTitle();
  const handleCheckboxClick = useCallback(
    (documentId) => {
      setItemsData((prevData) => toggleCheckboxState(prevData, documentId));

      if (!expandedAccordionIds.includes(documentId)) {
        toggle(documentId);
      }
    },
    [setItemsData, expandedAccordionIds, toggle],
  );

  const displayedTitle = getFileNameOrTitle(title, itemsData);

  return (
    <div
      className="d-flex align-items-center"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <Checkbox
        id={id}
        checked={checked}
        data-testid={`checkbox-on-${title}`}
        onChange={() => handleCheckboxClick(id)}
      />
      <label
        htmlFor={id}
        className="ms-2 text-gray-700 "
        onClick={() => handleCheckboxClick(id)}
      >
        {displayedTitle}
      </label>
    </div>
  );
};
